import { Box, Card, Separator, ShimmerText } from '@betterment/samba-react';
import { useParentSize } from '@visx/responsive';

import { LoadingAccountProjectionChart } from '../../../../Shared/components-v2/loading-Account-projection-chart/LoadingAccountProjectionChart';

const TITLE_WIDTH = '20%';

const DATE_WIDTH = '40%';
const BALANCE_WIDTH = '50%';
const EXPENSES_WIDTH = '60%';

const CHART_HEIGHT = 300;

const BalanceRowShimmer: React.FC = () => {
  return (
    <Box data-testid="balanceRowShimmer" css={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'space.400' }}>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.50' }}>
        <ShimmerText textStyle="text25" css={{ maxWidth: DATE_WIDTH }} />
        <ShimmerText textStyle="text300" css={{ maxWidth: BALANCE_WIDTH }} />
        <ShimmerText textStyle="text25" css={{ maxWidth: EXPENSES_WIDTH }} />
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.50' }}>
        <ShimmerText textStyle="text25" css={{ maxWidth: DATE_WIDTH }} />
        <ShimmerText textStyle="text300" css={{ maxWidth: BALANCE_WIDTH }} />
        <ShimmerText textStyle="text25" css={{ maxWidth: EXPENSES_WIDTH }} />
      </Box>
    </Box>
  );
};

interface Props {
  withBalances?: boolean;
  withHeaderContent?: boolean;
}

export const ForecasterProjectionLoadingState: React.FC<Props> = ({
  withBalances = false,
  withHeaderContent = false,
}) => {
  const { parentRef, width } = useParentSize();

  return (
    <Card role="status" aria-label="Loading...">
      <Card.Header css={{ padding: 'space.300', display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
        <ShimmerText textStyle="title100" css={{ maxWidth: TITLE_WIDTH }} />
        {withHeaderContent && (
          <ShimmerText data-testid="headerTextShimmer" textStyle="text50" css={{ maxWidth: '100%' }} />
        )}
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content css={{ p: 'space.300' }}>
        <Box
          ref={parentRef}
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'space.300',
            minWidth: 'size.0',
          }}
        >
          {withBalances && <BalanceRowShimmer />}

          <LoadingAccountProjectionChart width={width} height={CHART_HEIGHT} variant="loading" />
          <ShimmerText textStyle="text100" />
        </Box>
      </Card.Content>
    </Card>
  );
};
